import { ROBOT_MODEL } from 'types/models/Robot';

import {
  RobotManufacturerEnum,
  RobotModelEnum,
  RobotTypeEnum,
  type RobotModelConfig,
} from './types';
// ─── Model Configs ───────────────────────────────────────────────────────────

export const ROBOT_MODEL_CONFIGS: Record<RobotModelEnum, RobotModelConfig> = {
  [RobotModelEnum.Unknown]: {
    robotModel: RobotModelEnum.Unknown,
    robotType: RobotTypeEnum.Unknown,
    manufacturer: RobotManufacturerEnum.Unknown,
    usesRosAbstraction: false,
  },
  [RobotModelEnum.spot]: {
    robotModel: RobotModelEnum.spot,
    robotType: RobotTypeEnum.Quadruped,
    manufacturer: RobotManufacturerEnum.BostonDynamics,
    usesRosAbstraction: false,
  },
  [RobotModelEnum.matrice_4td]: {
    robotModel: RobotModelEnum.matrice_4td,
    robotType: RobotTypeEnum.Aerial,
    manufacturer: RobotManufacturerEnum.Dji,
    usesRosAbstraction: false,
  },
  [RobotModelEnum.magni]: {
    robotModel: RobotModelEnum.magni,
    robotType: RobotTypeEnum.Wheeled,
    manufacturer: RobotManufacturerEnum.Ubiquity,
    usesRosAbstraction: false,
  },
  [RobotModelEnum.anymal]: {
    robotModel: RobotModelEnum.anymal,
    robotType: RobotTypeEnum.Quadruped,
    manufacturer: RobotManufacturerEnum.ANYbotics,
    usesRosAbstraction: false,
  },
  [RobotModelEnum.turtlebot]: {
    robotModel: RobotModelEnum.turtlebot,
    robotType: RobotTypeEnum.Wheeled,
    manufacturer: RobotManufacturerEnum.ROBOTIS,
    usesRosAbstraction: false,
  },
  [RobotModelEnum.generic_quadcopter]: {
    robotModel: RobotModelEnum.generic_quadcopter,
    robotType: RobotTypeEnum.Aerial,
    manufacturer: RobotManufacturerEnum.Px4,
    usesRosAbstraction: true,
  },
  [RobotModelEnum.generic_rover]: {
    robotModel: RobotModelEnum.generic_rover,
    robotType: RobotTypeEnum.Wheeled,
    manufacturer: RobotManufacturerEnum.Ardupilot,
    usesRosAbstraction: true,
  },
  [RobotModelEnum.rb_watcher]: {
    robotModel: RobotModelEnum.rb_watcher,
    robotType: RobotTypeEnum.Wheeled,
    manufacturer: RobotManufacturerEnum.Robotnik,
    usesRosAbstraction: true,
  },
  [RobotModelEnum.smartphone]: {
    robotModel: RobotModelEnum.smartphone,
    robotType: RobotTypeEnum.Wearable,
    manufacturer: RobotManufacturerEnum.Misc,
    usesRosAbstraction: true,
  },
};

// ─── Lookup ──────────────────────────────────────────────────────────────────

export function getModelConfig(model: RobotModelEnum): RobotModelConfig {
  return ROBOT_MODEL_CONFIGS[model] ?? ROBOT_MODEL_CONFIGS[RobotModelEnum.Unknown];
}

const MODEL_NAME_TO_ENUM: Record<string, RobotModelEnum> = {
  [ROBOT_MODEL.SPOT]: RobotModelEnum.spot,
  [ROBOT_MODEL.DRONE]: RobotModelEnum.matrice_4td,
  [ROBOT_MODEL.MAGNI]: RobotModelEnum.magni,
  [ROBOT_MODEL.ANYMAL]: RobotModelEnum.anymal,
  [ROBOT_MODEL.TURTLEBOT]: RobotModelEnum.turtlebot,
  [ROBOT_MODEL.GENERIC_QUADROCOPTER]: RobotModelEnum.generic_quadcopter,
  [ROBOT_MODEL.GENERIC_ROVER]: RobotModelEnum.generic_rover,
  [ROBOT_MODEL.RB_WATCHER]: RobotModelEnum.rb_watcher,
  [ROBOT_MODEL.SMARTPHONE]: RobotModelEnum.smartphone,
};

export function getModelConfigByName(modelName: string): RobotModelConfig {
  const modelEnum = MODEL_NAME_TO_ENUM[modelName] ?? RobotModelEnum.Unknown;
  return getModelConfig(modelEnum);
}
